/**
 * Module-singleton exposing a "send" function for the active RealtimeClient.
 *
 * App.svelte constructs the client and registers its `send` here so leaf
 * components (Composer) can send WS frames without prop-drilling.
 * Mirrors the presence singleton pattern.
 *
 * Currently used by Composer to send `conversation.typing` frames for
 * WIDGET conversations — the gateway fans them to visitor:<visitorId>
 * so the customer widget renders "Support is typing…". META typing
 * continues to flow through the Meta send-action REST path.
 */

type SendFn = (payload: unknown) => void;

let _send: SendFn | null = null;

export function setRealtimeSender(send: SendFn | null): void {
  _send = send;
}

export function sendRealtimeFrame(payload: unknown): void {
  _send?.(payload);
}
